import * as React from 'react';
import { Logo } from '../../../../../commonv2/components/navigation/LikesLogo';
import './firstView.module.scss';
import { observer } from 'mobx-react';
import { TrialButton } from '../../../atoms/trial/TrialButton';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { FirstViewBackground } from '../../../atoms/trial/FirstViewBackGround';
import CareerFirstViewSp from './images/fv_img-sp.png';
import CareerFirstViewPc from './images/fv_img-pc.png';
import { LazyImage } from '../../../../../commonv3/components/atoms/images/LazyImage';

export const FirstViewMain = ({ isMobile }) => (
    <div styleName="first-view-main">
        <Logo styleName="eyecatch-logo" />
        <div styleName="career-image">
            <LazyImage src={isMobile ? CareerFirstViewSp : CareerFirstViewPc} alt="" />
        </div>
        <div styleName="first-view-text">
            私らしい働き方を実現する <br />
            女性のための<br />
            クリエイティブスクール
        </div>
        <div styleName="trial-btn-wrapper">
            <TrialButton styleName="trial-button">WEBで簡単！無料体験はこちら</TrialButton>
        </div>
        <div styleName="notes">
            ※期間を保証するものではなく過去実績より抜粋<br />
            ※2020年7月調査の副業等を含む成功報告の未経験者率
        </div>
    </div>
);

type Props = {};

@observer
export class FirstView extends React.Component<Props> {
    render() {
        const { isMobile } = GlobalStatesV3.viewport;
        return (
            <div id="top" styleName="first-view">
                <FirstViewBackground isMobile={isMobile} />
                <FirstViewMain isMobile={isMobile} />
            </div>
        );
    }
}
